'use client';

import Script from 'next/script';

/**
 * Google Consent Mode Default Configuration Component
 *
 * This component must render before GTM loads to ensure proper consent mode initialization.
 * It sets the default consent state to 'denied' for all non-essential categories.
 *
 * NOTE: Should only be used in the root layout.
 */
export default function ConsentModeDefault() {
  return (
    // eslint-disable-next-line @next/next/no-before-interactive-script-outside-document
    <Script id="consent-mode-default" strategy="beforeInteractive">
      {`
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('consent', 'default', {
          ad_storage: 'denied',
          analytics_storage: 'denied',
          ad_user_data: 'denied',
          ad_personalization: 'denied',
          functionality_storage: 'granted'
        });
      `}
    </Script>
  );
}
